export const ScheduleTransferStatus = {
  Pending: 'PENDING',
  Received: 'RECEIVED',
  MissingFiles: 'MISSING_FILES',
  FilesUploaded: 'FILES_UPLOADED',
  Rescheduled: 'RESCHEDULED',
  Canceled: 'CANCELED',
  Approved: 'APPROVED',
};
